module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [(this.$route.path !== '/admin/pendings-tasks') ? _c('HoursTasksComponent', {
    attrs: {
      "team_session": _vm.team_session,
      "account_session": _vm.account_session
    }
  }) : _vm._e(), _vm._v(" "), (_vm.boxedit && _vm.task_current) ? _c('TaskEditModal', {
    attrs: {
      "users": _vm.users,
      "states": _vm.states,
      "defineQuery": _vm.defineQuery,
      "usersession": _vm.usersession,
      "team_session": _vm.team_session,
      "task_current": _vm.task_current
    },
    on: {
      "taskEdited": _vm.taskEdited,
      "closeEditTask": function($event) {
        return _vm.closeEditTask()
      }
    }
  }) : _vm._e(), _vm._v(" "), (this.$route.path !== '/admin/pendings-tasks') ? _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-8"
  }, [_vm._v("\n          Tareas "), (_vm.account_session) ? _c('app-title-custom') : _vm._e(), _vm._v(" (" + _vm._s(_vm.filteredTasks.length) + ")\n        ")], 1), _vm._v(" "), (_vm.tasks_by_finish > 0) ? _c('div', {
    staticClass: "rounded-md flex items-center px-5 py-2 mt-2 mb-2 border cursor-pointer",
    class: [
      _vm.clic_taskspendingauth ?
      'border-theme-1 text-theme-1' :
      'border-theme-6 text-theme-6' ],
    on: {
      "click": function($event) {
        return _vm.taskPendingAuth()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.clic_taskspendingauth ?
    'Ver todas las tareas' :
    ("Ver " + _vm.tasks_by_finish + " tarea(s) pendiente(s) por finalizar.")) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-2 sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('app-icon', {
    attrs: {
      "name": "search",
      "classname": "w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.name),
      expression: "filter.name"
    }],
    staticClass: "input w-full sm:w-64 box px-10 text-gray-700",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por nombre"
    },
    domProps: {
      "value": (_vm.filter.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter dropdown hidden md:block md:absolute inset-y-0 mr-3 right-0 flex items-center"
  }, [_c('app-icon', {
    attrs: {
      "name": "chevron-down",
      "classname": "dropdown-toggle w-4 h-4 mt-3 cursor-pointer text-gray-700"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
  }, [_c('div', {
    staticClass: "dropdown-box__content box p-5"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.state),
      expression: "filter.state"
    }],
    staticClass: "input w-full border mt-2 flex-13",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione una opción")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return (state.id != 5) ? _c('option', {
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n                        " + _vm._s(state.name) + "\n                      ")]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Fecha entrega")]), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.date),
      expression: "filter.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filter.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Codigo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.slug),
      expression: "filter.slug"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por codigo"
    },
    domProps: {
      "value": (_vm.filter.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "slug", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Creada por")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.created_by),
      expression: "filter.created_by"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "created_by", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("Seleccione un usuario")]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n                        " + _vm._s(user.name) + "\n                      ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.start_date),
      expression: "filter.start_date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filter.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "start_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.end_date),
      expression: "filter.end_date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filter.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "end_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('button', {
    staticClass: "button mt-28 text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        _vm.filter = _vm.clearFilter()
      }
    }
  }, [_vm._v("\n                        Borrar Filtro\n                      ")])])])])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "intro-y w-full mt-2 mb-4 flex sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full hidden md:block sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex items-center sm:ml-auto mt-0 sm:mt-0"
  }, [(_vm.account_session) ? _c('button', {
    staticClass: "button button--sm mr-1 mb-1 mt-1",
    class: _vm.completed_tasks ?
      'bg-theme-1 text-white' :
      'border border-theme-1 border-theme-10 text-theme-10',
    on: {
      "click": function($event) {
        return _vm.viewTaskFinish()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.completed_tasks ?
    'Quitar tareas finalizadas' :
    'Ver tareas finalizadas') + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('button', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        return _vm.setCreateTaskModal(true)
      }
    }
  }, [_vm._v("\n              Crear tarea\n            ")])])])])]) : _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-10 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-8"
  }, [_vm._v("\n        Tareas Pendientes\n        "), (_vm.account_session) ? _c('app-title-custom') : _vm._e(), _vm._v("\n        (" + _vm._s(_vm.filteredTasks.length) + ")\n      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex items-center sm:ml-auto mt-0 sm:mt-0"
  }, [(_vm.account_session) ? _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.viewAccounts('all')
      }
    }
  }, [_vm._v("\n          Ver todas las cuentas\n        ")]) : _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.viewAccounts('one')
      }
    }
  }, [_vm._v("\n          Ver solo una cuenta\n        ")]), _vm._v(" "), (_vm.usersession.team_id == 1) ? _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.removeSupport()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.filter.support ? 'Quitar' : 'Agregar') + " Tareas de Soporte\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.assignedToMe()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.filter.assigned_to_me ?
    'Ver todas las tareas' :
    'Ver mis asignadas') + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredTasks), function(task) {
    return _c('tr', {
      staticClass: "intro-x zindex-0"
    }, [_c('td', [_c('a', {
      staticClass: "font-medium whitespace-no-wrap flex",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          task.campaign_attribute.project_account_id ==
            _vm.auth_session_account ?
            _vm.editTask(task) :
            _vm.viewAccountTask(task)
        }
      }
    }, [(task.path) ? _c('app-icon', {
      attrs: {
        "name": "link",
        "classname": "w-4 h-3 mt-1 mr-1"
      }
    }) : _vm._e(), _vm._v("\n                " + _vm._s(_vm._f("limit")(task.name.toUpperCase())) + "\n              ")], 1), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(task.slug) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(task.created_at) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center w-40"
    }, [_c('div', {
      staticClass: "text-center text-xs",
      class: [
        task.campaign_attribute.project_hours > 1 &&
        task.team_id == 1 ?
        'text-theme-1 font-bold' :
        '' ]
    }, [_vm._v("\n                " + _vm._s(task.campaign_attribute.project_name) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-center text-xs"
    }, [_vm._v("\n                " + _vm._s(task.campaign_attribute.project_account_name) + " -\n                " + _vm._s(task.campaign_attribute.project_account_country_prefix) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(task.campaign_attribute.name) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40"
    }, [_c('div', {
      staticClass: "flex items-center justify-center"
    }, [_vm._l((_vm.users), function(user) {
      return [(task.created_by === user.id) ? _c('div', {
        key: ("user-created_by-" + (user.id)),
        staticClass: "w-10 h-10 image-fit zoom-in"
      }, [_c('img', {
        staticClass: "tooltip rounded-full tooltipstered",
        attrs: {
          "alt": task.user_created_name,
          "src": user.avatar ?
            user.avatar :
            "/static/images/profile.png",
          "title": task.user_created_name
        }
      })]) : _vm._e()]
    }), _vm._v(" "), _vm._l((_vm.users), function(user) {
      return [(task.user_id === user.id) ? _c('div', {
        key: ("user-user_id-" + (user.id)),
        staticClass: "w-10 h-10 image-fit zoom-in -ml-5"
      }, [_c('img', {
        staticClass: "tooltip rounded-full tooltipstered",
        attrs: {
          "alt": task.user_name,
          "src": user.avatar ?
            user.avatar :
            "/static/images/profile.png",
          "title": task.user_name
        }
      })]) : _vm._e()]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "flex items-center justify-center"
    }, [_vm._v("\n                " + _vm._s(task.state_name) + " - " + _vm._s(task.hours) + "hs\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "button button--sm w-24 text-white",
      class: _vm.dateClass(task)
    }, [_vm._v("\n                " + _vm._s(task.date) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action"
    }, [(
      task.campaign_attribute.project_account_id ==
      _vm.auth_session_account
    ) ? _c('div', {
      staticClass: "flex justify-center items-center"
    }, [(task.state_id != 4) ? _c('a', {
      staticClass: "cursor-pointer flex items-center mr-3",
      on: {
        "click": function($event) {
          return _vm.editTask(task)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v(" Editar\n                ")], 1) : _c('a', {
      staticClass: "cursor-pointer flex items-center mr-3",
      on: {
        "click": function($event) {
          return _vm.viewTask(task)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "eye",
        "classname": "w-5 h-5 mr-2"
      }
    }), _vm._v(" Ver\n                ")], 1), _vm._v(" "), _c('a', {
      staticClass: "cursor-pointer flex items-center mr-3",
      on: {
        "click": function($event) {
          return _vm.createDuplicateModal(task)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "duplicate",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("\n                  Duplicar\n                ")], 1)]) : _c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('a', {
      staticClass: "cursor-pointer flex items-center mr-3",
      on: {
        "click": function($event) {
          return _vm.viewAccountTask(task)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "folder",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v(" Editar\n                ")], 1)])])])
  }), 0)])])], 1) : _c('app-loading'), _vm._v(" "), (_vm.createTaskModal) ? _c('CreateTaskModal', {
    attrs: {
      "task": _vm.task,
      "options": _vm.options,
      "defineQuery": _vm.defineQuery,
      "team_session": _vm.team_session
    },
    on: {
      "addTag": _vm.addTag,
      "closeModal": function($event) {
        return _vm.setCreateTaskModal(false)
      },
      "taskCreated": function($event) {
        return _vm.taskCreated()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showDuplicateModal) ? _c('DuplicateTaskComponent', {
    attrs: {
      "task": _vm.task_duplicate
    },
    on: {
      "clearDuplicateTask": function($event) {
        _vm.showDuplicateModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.task_view) ? _c('ViewTaskModal', {
    attrs: {
      "task": _vm.task_view
    },
    on: {
      "closeModal": function($event) {
        _vm.task_view = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-xs"
  }, [_vm._v("\n                      Desde "), _c('span', [_vm._v("(Fecha creación)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-xs"
  }, [_vm._v("\n                      Hasta "), _c('span', [_vm._v("(Fecha creación)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "whitespace-no-wrap"
  }, [_vm._v("NOMBRE")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("PROYECTO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ESTADO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("FECHA ENTREGA")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-211fbfcd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/task/TaskComponent.vue
// module id = 418
// module chunks = 1